module.exports = __webpack_public_path__ + "img/look8.e56095f5.png";